



















































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import Utils from '@root/utils/common';
import OrganizationSearch from '@/components/organization-search/index.vue';
// 导入字典
import {
  dictoperationTypeMap,
  dictIssuedOpinionMap,
  dictopOpinionMap
} from '@/types/special-authorized-car-management/dictionaries';

import {} from '../router-names';

// axios请求
import { queryserchRuleMonitoringRecord } from '@/api/monitor-alarm-center/index';
import { CLEAN_CAR } from '../../exception-management/router-names';
import lodash from 'lodash';
import { post, download } from '@root/utils/httpWrap';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import moment from 'moment';
@Component({
  name: 'OperationRecord',
  components: {
    ParkingLotSearch,
    OrganizationSearch
  }
})
export default class OperationRecord extends Mixins(TableMixin, TableWidthMixin) {
  tableLoading = false;
  tableData: any[] = []; // 表数据
  form = null;

  filterParam: any = {
    parkId: null, // 车场ID,多个车场ID逗号分隔
    organId: null,
    monitorEvent: undefined,
    startCreateTime: '',
    endCreateTime: ''
  };

  sectionVisible = false;
  userVisible = false;

  copiedFilterParam = null;

  private moment = moment;
  // 默认创建日期
  get defaultTime() {
    if (this.filterParam.startCreateTime && this.filterParam.endCreateTime) {
      return [
        this.moment(this.filterParam.startCreateTime, 'YYYY-MM-DD'),
        this.moment(this.filterParam.endCreateTime, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.startCreateTime) {
      return [this.moment(this.filterParam.startCreateTime, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '监控类型/事件',
        dataIndex: 'ruleType',
        width: 240,
        scopedSlots: { customRender: 'rule-type' }
      },
      {
        title: '事件详情',
        dataIndex: 'eventDetail',
        width: 450,
        scopedSlots: { customRender: 'events-details' }
      },
      {
        title: '推送岗位组',
        dataIndex: 'positionNum',
        width: 140,
        scopedSlots: { customRender: 'push-post-section' }
      },

      {
        title: '推送用户',
        dataIndex: 'pushNum',
        width: 140,
        scopedSlots: { customRender: 'push-the-user' }
      },
      {
        title: '记录时间',
        dataIndex: 'createTime',
        width: 200,
        customRender: (text: any) => text || '--'
      }
    ];
  }

  // 授权状态 ：00 待审核 01 生效中， 02 已生效 ，03 已退费 ，04 已过期
  operationTypeOptions: IOption[] = Utils.toLabelVal(dictoperationTypeMap);
  // 操作类型 01新增 02续期 03审核通过 04审核拒绝 05删除
  opOpinion: IOption[] = Utils.toLabelVal(dictopOpinionMap);
  // // 是否生效
  // effectOptions: IOption[] = Utils.toLabelVal(dictEffectTypeMap)
  // DictEffectType = DictEffectType
  // dictEffectTypeMap = dictEffectTypeMap

  /**
   * 生命周期钩子函数
   */
  async created() {
    this.copiedFilterParam = lodash.mergeWith({}, this.filterParam);
    if (process.env.NODE_ENV == 'development') {
      (window as any)._self = this;
    }
    // @ts-ignore
    const ress = await Promise.allSettled([
      this.fetchTableData(),
      post('/bangdao/saasapi/v1/baseRuleMonitoring/getRuleMonitoringEvent', {})
    ]);
    try {
      // @ts-ignore
      const data = ress[1].value.data;

      data.forEach((row: { value: number }) => {
        row.value = Math.random();
      });

      this.eventsOption = data;
    } catch (e) {
      this.$message.error('获取监控事件失败');
    }
    // 特殊车辆类型列表初始化
    // this.fetchTableData()
  }

  eventsOption = [];
  pushedJobsArr = [];
  async showSection(row) {
    this.pushedJobsArr = (await post('/bangdao/saasapi/v1/baseRuleMonitoring/applyJobByRecordId', {
      recordId: row.recordId
    })).data;
    this.sectionVisible = true;
  }
  handleCancelclose() {
    this.sectionVisible = false;
  }
  pushUsersArr = [];
  async showUser(row) {
    this.pushUsersArr = (await post('/bangdao/saasapi/v1/baseRuleMonitoring/applyUserByRecordId', {
      recordId: row.recordId
    })).data;
    this.userVisible = true;
  }
  handleUserclose() {
    this.userVisible = false;
  }
  tosetCleaning(row) {
    this.$router.push({
      name: CLEAN_CAR,
      params: {}
    });
  }
  /**
   * 请求列表数据
   */
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return;
    this.tableLoading = true;
    if (isRefresh) this.current = 1;

    const d = lodash.cloneDeep(this.filterParam),
      eventsChild = (this.eventsOption.find((item: any) => item.value == d.monitorEvent) || {}).children || null;
    if (eventsChild) {
      d.monitorEvent = eventsChild.map((item: any) => item.value).join(',');
    }
    try {
      const res = await post('/bangdao/saasapi/v1/baseRuleMonitoring/serchRuleMonitoringRecord', {
        ...d,
        // parkId: this.parkId,
        // startTime: this.start_time,
        // endTime: this.end_time,
        // plate: this.plateHead + this.plateTail,
        // authTypeName: this.authTypeName,
        // operateType: this.operate_type.join(','),
        // status: this.status,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { data } = res;
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      // const { datas = [], totalNum = 0 } = data || {}
      this.tableData = data.datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
      return datas;
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
      return [];
    } finally {
      this.tableLoading = false;
    }
  }
  /**
   * 查询条件清空
   */
  onTableFilterClear() {
    this.filterParam = lodash.cloneDeep(this.copiedFilterParam);
    // this.dateTime = []
    // this.start_time = ''
    // this.end_time = ''
    // this.plateCar = true
    // this.plateHead = ''
    // this.plateTail = ''
    // this.authTypeName = ''
    // this.operate_type = []
    // this.status = ''
    this.fetchTableData(true);
  }

  // 获取操作时间
  onOperateTime(date: any, dateString: any[]) {
    this.filterParam.startCreateTime = dateString[0];
    this.filterParam.endCreateTime = dateString[1];
  }
}
